import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {AuthClaimReadDto, UserReadExtendedDto} from "../../../api_client";
import {IAuthError} from "../types";

export interface ILoadingState {
  signIn: boolean;
  signOut: boolean;
  getCurrentUser: boolean;
  endImpersonation: boolean;
  impersonateUser: boolean;
}
interface SetLoadingPayload {
  type: keyof ILoadingState;
  isLoading: boolean;
}

export interface IRestore {
  login: string;
  token: string;
}

interface IAuthState {
  data: {
    isAuth: boolean;
    user?: UserReadExtendedDto;
    userClaims?: AuthClaimReadDto[];
  };
  restore?: IRestore;
  error?: IAuthError;
  loading: ILoadingState;
}

const initialState: IAuthState = {
  data: {
    isAuth: false,
    user: {}
  },
  loading: {
    signIn: false,
    signOut: false,
    getCurrentUser: false,
    endImpersonation: false,
    impersonateUser: false
  }
};

const slice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setLoading(state, action: PayloadAction<SetLoadingPayload>) {
      const {type, isLoading} = action.payload;
      state.loading[type] = isLoading;
    },
    setError(state, action: PayloadAction<IAuthError | undefined>) {
      const error = action.payload;
      if (error && error.code === "LOCKED") {
        error.lockoutEnd = new Date(error.lockoutEnd);
      }
      state.error = error;
    },
    setIsAuth(state, action: PayloadAction<boolean>) {
      state.data.isAuth = action.payload;
    },
    setUser(state, action: PayloadAction<UserReadExtendedDto>) {
      state.data.user = action.payload;
    },
    setUserClaims(state, action: PayloadAction<AuthClaimReadDto[]>) {
      state.data.userClaims = action.payload;
    },
    setRestore(state, action: PayloadAction<IRestore>) {
      state.restore = action.payload;
    },
    /** Сброс сессии без затрагивания loading (logout, ошибка refresh). */
    clearAuthData(state) {
      state.data.isAuth = false;
      state.data.user = {};
      state.data.userClaims = [];
      state.error = undefined;
    },
    /**
     * Сброс loading-флагов browser-navigation (impersonate / end / logout).
     * После location.href Redux может восстановиться из bfcache с isLoading=true.
     */
    resetNavigationLoading(state) {
      state.loading.signOut = false;
      state.loading.endImpersonation = false;
      state.loading.impersonateUser = false;
    }
  }
});

export const {reducer: authReducer, ...authStore} = slice;
